import { api } from '@System/api';

export default {
    getListWarehouses: params => api.get("/merchant/warehouses/items", {params, singleRequest: true, loading: false}),
};
